/************************************************
 * REVISION 1.0
 * Fecha: 05/03/2023
 *
 * @description JS para manejo de labels ES
 * @author mixtico
 * @version 1.0
 *
 ***********************************************/
export const properties = {
  /** General */

  /** footer */
  com_mixtico_label_footer_terms_conditions: "Términos y Condiciones",

  /** Page not found */
  com_mixtico_label_page_404_title: "Oops!",
  com_mixtico_label_page_404_subtitle: "Página no encontrada",

  /** Loading */
  com_mixtico_label_loading_title: "Cargando",

  /** General label */
  com_mixtico_label_yes: "Si",
  com_mixtico_label_not: "No",
  /** General error labels in forms */
  com_mixtico_label_field_required: "Campo obligatorio",
  com_mixtico_label_field_format: "Formato invalido",

  /** General button labels */
  com_mixtico_label_button_accept_title: "Aceptar",
  com_mixtico_label_button_ok_title: "Ok",
  com_mixtico_label_button_cancel_title: "Cancelar",
  com_mixtico_label_button_save_title: "Registrar",
  com_mixtico_label_button_update_title: "Editar",
  com_mixtico_label_button_detail_title: "Ver detalle",
  com_mixtico_label_button_changestate_title: "Cambiar estado",
  com_mixtico_label_button_delete_title: "Eliminar",
  com_mixtico_label_button_back_title: "Atras",
  com_mixtico_label_button_back2_title: "Volver",
  com_mixtico_label_button_add_title: "Agregar",
  com_mixtico_label_button_search_title: "Buscar",
  com_mixtico_label_button_clear_title: "Limpiar",
  com_mixtico_label_button_login_title: "Iniciar Sesión",
  com_mixtico_label_button_close_title: "Cerrar",
  com_mixtico_label_button_view_title: "Ver",
  com_mixtico_label_button_exit_title: "Salir",


  /** Event labels*/
  com_mixtico_label_event_fetch_error: "Error en proceso de obtener eventos",

  /** Email labels*/
  /** Email service message success*/
  com_mixtico_label_email_send_success: "Pronto lo contactaremos",
  /** Email service message error*/
  com_mixtico_label_email_send_error: "Error en proceso de envío de correo electrónico",
  

};
